import { getSize } from '../theme/iconSizes'
import IconProps from './Icon'

const ArrowUp = ({ iconSize, strokeWidth = 3, stroke = 'currentColor' }: IconProps) => {
  const size = getSize(iconSize)

  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <polyline points="1 17 12 7 23 17" stroke={stroke} strokeWidth={strokeWidth} />
      </g>
    </svg>
  )
}

export default ArrowUp
